<template>
  <qx-card-form :title="'申请转移为' + vehicleClassName" v-show="showComponent">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {
  getFileUrl,
} from 'api';
const imgName = 'adriverLicenseList';
export default {
  data () {
    return {
      vehicleClassName: '',
      showComponent: false,
      currentSelectVehicleClass: '',
      // 不能删除，用来接收数据的
      otherFormData: {},
      baseForm: {
        form: [
          {
            label: '申请说明',
            value: 'applyRemark',
            type: 'input',
            width: '430px',
            hide: false,
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
          {
            label: '行驶证正本',
            value: 'adriverLicenseList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            hide: true,
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: {
          applyRemark: [
            { required: true, message: '请输入邀请说明', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        const imgField = imgName.substring(imgName.indexOf('List'), 0);
        if (formData[imgName] && formData[imgName].length) {
          formData[imgField] = formData[imgName][0].id;
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      formData.currentSelectVehicleClass = this.currentSelectVehicleClass;
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        if (this.showComponent) {
          // 如果该组件显示，代表是申请状态
          // 源码是写死了提交 0
          formData.applyState = '0';
        } else {
          // 如果组件隐藏了，代表不是邀请状态，之所以要删除掉这个参数，是因为请求前会根据这个参数选择是否调用邀请接口
          delete formData.applyRemark;
        }
      }
      // console.log('申请信息提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      this.resetBaseForm();
      let flowIds = [];
      // 获取详情接口返回的的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
      const imgField = imgName.substring(imgName.indexOf('List'), 0);
      // 例如 drivingLicense 有图片id值，代表有图片，传图片id到另外一个接口获取图片url
      if (data[imgField]) {
        flowIds.push(data[imgField]);
      } else {
        // 如果没有数据，则设置为空数组，防止报错
        data[imgName] = [];
      }

      if (flowIds.length) {
        const imgRes = await getFileUrl({
          flowIds: flowIds.join(),
        });
        const imgField = imgName.substring(imgName.indexOf('List'), 0);
        imgRes.items.forEach((item) => {
          if (`${item.flowId}` === `${data[imgField]}`) {
            if (data[imgField]) {
              data[imgName + 'Url'] = item.fullPath;
              data[imgName] = [{
                id: `${item.flowId}`,
                url: item.fullPath,
              }];
            }
          }
        });
      }
      this.vehicleClassChange(data.currentSelectVehicleClass);
      this.$refs.baseForm.setVal(data);
    },
    vehicleClassChange (vehicleClass) {
      // 如果是外调车修改状态，如果修改了【车辆类型】，需要出现该组件
      if (this.$route.query.id && this.$route.query.type === 'outward') {
        if (vehicleClass && (this.$route.query.vehicleClass !== vehicleClass)) {
          // 如果更改了车辆类型，出现该组件
          let pageTitle = '';
          let adriverLicenseListDisabled = false;
          switch (vehicleClass) {
            case '1':
              pageTitle += '自有车';
              break;
            case '2':
              pageTitle += '招商车';
              break;
            case '3':
              pageTitle += '外调车';
              break;
            case '4':
              pageTitle += '挂靠车';
              break;
            default:
              break;
          }
          this.vehicleClassName = pageTitle;
          this.currentSelectVehicleClass = vehicleClass;
          this.showComponent = true;
          this.baseForm.rules.applyRemark[0].required = true;
          if (vehicleClass !== '1') {
            // 如果想申请转移为自有车，多显示一个行驶证正本
            adriverLicenseListDisabled = true;
          }
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: adriverLicenseListDisabled,
            names: ['adriverLicenseList'],
          });
        }
      }
    },
    resetBaseForm () {
      this.showComponent = false;
      this.currentSelectVehicleClass = '';
      this.baseForm.rules.applyRemark[0].required = false;
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['adriverLicenseList'],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
